import {Injectable} from '@angular/core';
import {Session} from './Session';
import {CURRENCY_LOCALE_MAPPER} from '../constants/Currency.constants';

declare var moment: any;

@Injectable({
  providedIn: 'root'
})
export class DateFormater {

    constructor() {
    }

    formatDate(input, currentFormat, ExpectedFormat) {
        return moment(input, currentFormat).format(ExpectedFormat);
    }

    getFormat() {

        const localeFormat = CURRENCY_LOCALE_MAPPER[Session.getCurrentCompanyCurrency()] ? CURRENCY_LOCALE_MAPPER[Session.getCurrentCompanyCurrency()] : 'en-US';

        if (localeFormat == 'en-IN'){
            return 'DD-MM-YYYY';
        }else if (localeFormat == 'id-ID'){
            return 'DD-MM-YYYY';
        }else if (localeFormat == 'en-US') {
            return 'MM-DD-YYYY';
        }else if (localeFormat == 'en-ca') {
          return 'MM-DD-YYYY';
        }else if (localeFormat == 'ind') {
          return 'DD-MM-YYYY';
        }else if (localeFormat == 'en-au') {
            return 'DD-MM-YYYY';
        }else {
          return 'MM-DD-YYYY';
        }
    }

    getServiceDateformat(){
        return 'MM/DD/YYYY';
    }
}
